import { getField, updateField } from "vuex-map-fields";
import Repository from "@/repository";

const PARTCATEGORY_API = "/partCategory";

// ----------------------- STATE ------------------------- //
const state = {
  partcategory_data: [],
  currentIndex: -1
};

// ----------------------- GETTERS ----------------------- //
const getters = {
  getPartCategory: state =>
    getField(state.partcategory_data[state.currentIndex]),

  getCurrentPartCategory: state => {
    return state.partcategory_data[state.currentIndex];
  }
};

// ----------------------- MUTATIONS -------------------- //
const mutations = {
  updatePartCategory(state, payload) {
    updateField(state.partcategory_data[state.currentIndex], payload);
  },

  setCurrentIndexByID(state, theID) {
    state.currentIndex = state.partcategory_data.findIndex(
      partcategory => partcategory.id == theID
    );
  },

  loadAllPartCategorys(state, payload) {
    state.partcategory_data = payload.data;
    state.currentIndex = 0;
  },

  addPartCategory(state, payload) {
    state.partcategory_data.push(payload.data);
    state.currentIndex = state.partcategory_data.length - 1;
  },

  savePartCategory(state, payload) {
    state.partcategory_data[state.currentIndex] = payload.data;
  },

  fetchPartCategory(state, payload) {
    if (state.currentIndex == -1) {
      state.partcategory_data.push(payload.data);
      state.currentIndex = 0;
    } else {
      state.partcategory_data[state.currentIndex] = payload.data;
    }
  },

  deletePartCategory(state, payload) {
    state.currentIndex = state.partcategory_data.findIndex(
      partcategory => partcategory.id == payload.data.id
    );
    state.partcategory_data.splice(state.currentIndex, 1);
  },
  reset(state) {
    state.partcategory_data = []
    state.currentIndex = -1
  }
};

// ----------------------- ACTIONS -------------------- //
const actions = {
  async loadAllPartCategorys({ commit }) {
    try {
      commit(
        "loadAllPartCategorys",
        await Repository.get(`${PARTCATEGORY_API}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async addPartCategory({ commit }) {
    await Repository.get(`${PARTCATEGORY_API}/new`)
      .then(response => {
        commit("addPartCategory", response);
      })
      .catch(error => {
        console.log(error);
      });
  },

  async savePartCategory({ state, commit }) {
    try {
      commit(
        "savePartCategory",
        await Repository.post(
          `${PARTCATEGORY_API}`,
          state.partcategory_data[state.currentIndex]
        )
      );
    } catch (error) {
      console.log(error);
    }
  },

  async fetchPartCategory({ commit }, payloadID) {
    try {
      commit(
        "fetchPartCategory",
        await Repository.get(`${PARTCATEGORY_API}/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async deletePartCategory({ commit }, payloadID) {
    try {
      commit(
        "deletePartCategory",
        await Repository.delete(`${PARTCATEGORY_API}/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async searchPartCategorys({ commit }, searchTerm) {
    try {
      commit(
        "loadAllPartCategorys",
        await Repository.get(`${PARTCATEGORY_API}/search?q=${searchTerm}`)
      );
    } catch (error) {
      console.log(error);
    }
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
